<script setup lang="ts">
import { AppStars } from '@libs/ui';

import type { HotelDetailsHeaderData } from '../../models';

interface HotelDetailsHeaderProps {
  headerData: HotelDetailsHeaderData;
}

const props = defineProps<HotelDetailsHeaderProps>();
</script>

<template>
  <header class="hotel-details-header">
    <div class="header-text">{{ props.headerData.headerText }}</div>
    <div v-if="props.headerData.subHeaderText" class="subheader-text">
      {{ props.headerData.subHeaderText }}
    </div>
    <AppStars :amount="props.headerData.starsAmount" size="24" />
  </header>
</template>

<style scoped lang="scss">
.hotel-details-header {
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  gap: var(--spacing-8);
  padding-bottom: var(--spacing-16);

  .header-text {
    color: var(--color-neutral-70);
    @include font-heading-4;

    @include for-more-or-equal-than-599-px {
      @include font-heading-3;
    }
  }

  .subheader-text {
    color: var(--color-neutral-70);
    @include font-preamble-2;
  }
}
</style>
